<template>
  <section class="partners-section">
    <div class="section-header">
      
      <h2 class="section-title">
        <span>{{ t('Agents.title') }}</span>
      </h2>
      
    </div>

    <div class="partners-grid glass-panel">
      <a
        v-for="partner in partners"
        :key="partner.id"
        :href="partner.link"
        target="_blank"
        rel="noopener noreferrer"
        class="partner-card"
      >
        <img :src="partner.light" class="partner-logo dark:hidden" :alt="partner.name" />
        <img :src="partner.dark" class="partner-logo hidden dark:block" :alt="partner.name" />
      </a>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

import img1Light from '@/assets/Agents/1_light.png';
import img2Light from '@/assets/Agents/2_light.png';
import img3Light from '@/assets/Agents/3_light.png';
import img4Light from '@/assets/Agents/4_light.png';
import img5Light from '@/assets/Agents/5_light.png';

import img1Dark from '@/assets/Agents/1_dark.png';
import img2Dark from '@/assets/Agents/2_dark.png';
import img3Dark from '@/assets/Agents/3_dark.png';
import img4Dark from '@/assets/Agents/4_dark.png';
import img5Dark from '@/assets/Agents/5_dark.png';

const partners = computed(() => ([
  { id: 1, name: 'Partner 1', light: img1Light, dark: img1Dark, link: 'https://example1.com' },
  { id: 2, name: 'Partner 2', light: img2Light, dark: img2Dark, link: 'https://example2.com' },
  { id: 3, name: 'Partner 3', light: img3Light, dark: img3Dark, link: 'https://example3.com' },
  { id: 4, name: 'Partner 4', light: img4Light, dark: img4Dark, link: 'https://example4.com' },
  { id: 5, name: 'Partner 5', light: img5Light, dark: img5Dark, link: 'https://example5.com' },
]));
</script>

<style scoped>
.partners-section {
  padding: 6rem 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
  padding: 2rem;
}

.partner-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  border-radius: 1.25rem;
  border: 1px solid rgba(91, 91, 91, 0.08);
  background: rgba(255, 255, 255, 0.9);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.partner-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 55px rgba(12, 12, 12, 0.12);
}

.partner-logo {
  max-width: 140px;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.dark .partner-card {
  background: rgba(8, 11, 16, 0.75);
  border-color: rgba(253, 143, 66, 0.15);
}
</style>